<template>
  <div class="pricing-container" :class="{'pricing-container-mobile': fromMobile}">
    <div id="pricing-compare">
      <div
        v-if="$store.state.plan && $store.state.plan.type !== 'pro-yearly' &&
          $store.state.plan.group !== 'white-label'"
      >
        <div class="pricing-plan-edu" v-if="isShowBackToNonEdu">
          <span class="back-non-edu-plan  flex justify-center gap-2 ">
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.219738 6.59278C-0.073245 6.2648 -0.073245 5.73218 0.219738 5.40421L3.21988 2.04578C3.51287
              1.71781 3.98867 1.71781 4.28165 2.04578C4.57464 2.37375 4.57464 2.90638 4.28165 3.23435L2.56126
              5.1602L11.25 5.1602C11.6648 5.1602 12 5.5354 12 5.9998C12 6.46421 11.6648 6.83941 11.25 6.83941L2.56126
              6.83941L4.28165 8.76526C4.57464 9.09323 4.57464 9.62585 4.28165 9.95383C3.98867 10.2818 3.51287 10.2818
              3.21988 9.95383L0.219738 6.5954V6.59278Z"
                fill="#348EF6"
              />
            </svg>
            <a class="primary" href="javascript:void(0);" @click="backToNonEducational">
              {{ $i18nPresenter.t('Back to Non-educational plans') }}
            </a>
          </span>
          <div class="pricing-toggle-title">
            {{ $i18nPresenter.t('Educational Plans') }}
          </div>
          <div class="pricing-decs-edu">
            {{ $i18nPresenter.t('Special pricing for teachers, students, and nonprofit organisations.') }}
          </div>
        </div>
        <div v-else :class="{'show-edu-plan': isShowBackToNonEdu}" class="pricing-desktop ">
          <div class="flex gap-2 justify-center items-center pricing-toggle-wrapper">
            <div :class="{'font-bold-v2': !isAnnual}" class="aha__save">
              {{ $i18nPresenter.t('Monthly') }}
            </div>
            <toggle-button
              :sync="true"
              :value="isAnnual"
              :width="45"
              :height="28"
              class="mb-0"
              :color="{
                checked: '#348EF6',
                unchecked: '#D3D7E1'
              }"
              @change="toggleButtonSwitch()"
            />
            <div class="flex flex-row items-center gap-1 relative" :class="{'font-bold-v2': isAnnual}">
              {{ $i18nPresenter.t('Yearly') }}
              <div class="pricing-label-discount">
                <p>{{ $i18nPresenter.t('Save up to 67%') }}</p>
              </div>
            </div>
          </div>
        </div>
        <!--      add css taiwind mobile show up -->
        <div class="pricing-desktop ">
          <PricingDesktop
            :planName="planName"
            :toggleButtonSwitch="toggleButtonSwitch"
            @learnMore="learnMore"
            :permission="permission"
            @upgradePlan="upgradePlan"
          />

          <div class="title-open-edu py-2 mb-6" v-if="isShowTitleOpenEdu">
            <span>
              <b>{{ $i18nPresenter.t('Educational plans') }}</b>
            </span> —  {{ $i18nPresenter.t('Special rates for teachers, students and nonprofit organisations.') }}
            <a class="primary" href="#upgrade-your-plan" @click="openEducation()">
              {{ $i18nPresenter.t('Learn more') + ' ' }}
            </a>
            <svg
              width="12"
              height="10"
              viewBox="0 0 12 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
            >
              <path
                d="M11.7803 5.59278C12.0732 5.2648 12.0732 4.73218 11.7803 4.40421L8.78012
              1.04578C8.48713 0.717812 8.01133 0.717812 7.71835 1.04578C7.42536 1.37375 7.42536
              1.90638 7.71835 2.23435L9.43874 4.1602L0.750037 4.1602C0.335173 4.1602 0 4.5354 0 4.9998C0
              5.46421 0.335173 5.83941 0.750037 5.83941L9.43874 5.83941L7.71835 7.76526C7.42536 8.09323
              7.42536 8.62585 7.71835 8.95383C8.01133 9.2818 8.48713 9.2818 8.78012 8.95383L11.7803 5.5954V5.59278Z"
                fill="#348EF6"
              />
            </svg>
          </div>
        </div>
      </div>
      <BulkPricing v-if="canShowBulkPricingSection" />
      <ComparePlansSection
        :billingCycle="planName"
        :togglePlan="_togglePlan"
        :permission="permission"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Config from '@/config'
import Utils from '@/util'
import PricingDesktop from './PricingDesktop.vue'
import ComparePlansSection from './ComparePlansSection.vue'

import eventCategories from '@/constant/eventCategories'
import EventBus from '@/eventBus'
import BulkPricing from '@/components-v2/my-plan/user-pricing-v2/BulkPricing.vue'

const PLAN_GROUPS = ['annual', 'one-time', 'educational', 'monthly']
export default {
  name: 'UserPricing',
  components: {
    BulkPricing,
    ComparePlansSection,
    PricingDesktop,
  },
  props: {
    permission: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      hiddenPlanEdu: true,
      showTitleOpenEdu: true,
      planName: 'annual',
      planColour: '',
      showDetails: false,
      domain: '',
      fromMobile: false,
    }
  },
  computed: {
    ...mapGetters([
      'currentUserIsTeamOwnerOrAdmin',
      'isTeamCreatedByCustomerSuccess',
    ]),
    ...mapState({
      currentUser: (state) => state.currentUser,
      currentAccount: (state) => state.currentAccount,
    }),
    isShowBackToNonEdu() {
      return !this.showTitleOpenEdu && this.abTestOpenEdu
    },
    isAnnual() {
      return this.planName == 'annual'
    },
    isShowTitleOpenEdu() {
      return this.showTitleOpenEdu && this.abTestOpenEdu
    },
    isHiddenSwitchPlanEdu() {
      return this.hiddenPlanEdu && this.abTestOpenEdu
    },
    abTestOpenEdu() {
      return true
    },
    canShowBulkPricingSection() {
      if (!this.currentAccount || !this.currentAccount.id) return true
      return this.currentUserIsTeamOwnerOrAdmin &&
          !this.isTeamCreatedByCustomerSuccess &&
          (this.currentAccount.plan == 'free' || this.currentAccount.plan == null) &&
          this.planName !== 'educational'
    },
  },
  mounted() {
    this.domain = Config.domain
    if (PLAN_GROUPS.includes(Utils.getParamValue('planGroup'))) {
      this.planName = Utils.getParamValue('planGroup')
    }

    EventBus.$on('clickShowEduPlan', () => {
      this.openEducation(true)
    })
  },
  destroyed() {
    EventBus.$off('clickShowEduPlan')
  },
  methods: {
    toggleButtonSwitch() {
      if (this.planName === 'annual') {
        this._togglePlan('monthly')
      } else {
        this._togglePlan('annual')
      }
    },
    isProPlan() {
      return this.$store.state.plan.group == 'pro'
    },
    isWhiteLabel() {
      return this.$store.state.plan.group === 'white-label'
    },
    openEducation(fromMobile = false) {
      Utils.mixpanelTracking('My plan', 'Show Plan Edu')
      this.fromMobile = fromMobile
      this._togglePlan('educational')
    },
    backToNonEducational() {
      Utils.mixpanelTracking('My plan', 'Show Non-Edu Plans')
      this.showTitleOpenEdu = true
      this.$emit('back-to-non-edu', true)
      this._togglePlan('annual')
    },
    learnMore(plan) {
      Utils.mixpanelTracking(eventCategories.MY_PLAN, 'Learn more', plan)
      const element = document.getElementById('sticky-wrapper')
      const top = element.offsetTop - 50
      window.scrollTo(0, top)
    },
    upgradePlan(planType) {
      Utils.mixpanelTracking('My plan > Upgrade > Top', 'Upgrade', planType)
      setTimeout(() => {
        window.location.href = `${Config.presenterDomain}/apps/upgrade/${planType}`
      }, 500)
    },
    togglePlanEduByPlan(plan) {
      if (plan !== 'educational') {
        this.showTitleOpenEdu = true
        this.hiddenPlanEdu = true
      } else {
        this.showTitleOpenEdu = false
      }
    },

    _togglePlan(plan) {
      if (!plan) return
      this.togglePlanEduByPlan(plan)
      this.planName = plan
      Utils.mixpanelTracking(
        eventCategories.MY_PLAN,
        'Change Plan Tab',
        plan,
      )
    },
    _showMobileDetailsPlan(planColour, planName) {
      const showDetails = this.$refs[`show-${planColour}${planName}`]
      const hideDetails = this.$refs[`hide-${planColour}${planName}`]
      const details = this.$refs[`details-${planColour}${planName}`]
      showDetails.classList.remove('active')
      hideDetails.classList.add('active')
      details.classList.add('active')
      this.planColour = planColour
      this.planName = planName
    },
    _hideMobileDetailsPlan(planColour, planName) {
      const showDetails = this.$refs[`show-${planColour}${planName}`]
      const hideDetails = this.$refs[`hide-${planColour}${planName}`]
      const details = this.$refs[`details-${planColour}${planName}`]
      showDetails.classList.add('active')
      hideDetails.classList.remove('active')
      details.classList.remove('active')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.pricing-container {
  @apply py-4 w-full;
}
.pricing-toggle-wrapper{
  @apply flex justify-center;
  font-size : 20px;
  color: var(--base-80, #707070);
}
.pricing-toggle {

  @apply flex justify-center;
  display: none;
  font-size : 20px;
}
.pricing-toggle-title{
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  //margin-bottom: 32px;
  line-height: 54px; /* 135% */
  text-align: center;
  margin: 8px 0px;
}

.pricing-plan-edu{
  text-align: center;
  .pricing-decs-edu{
    color: var(--base-80, #707070);
    text-align: center;
    font-size: 16px;
    font-weight: 400;
  }
}
.pricing-label-discount {

  color: var(--green-100, #15A962);
  border-radius: 4px;
  background: var(--green-10, #EBF9F1);
  font-family: Nunito;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  padding:4px 8px;
}
@media (max-width: 768px){
  .pricing-label-discount {
    position: relative;
    left:0px;
    width: inherit;
  }
  .pricing-toggle-title{
    display: none;
  }
  .pricing-decs-edu{
    display: none;
  }

}
.font-bold-v2{
  font-weight: bold;
  color : #0A0A0A;
}

.pricing-mobile {
  font-size: 14px;
  display: none;
  margin-top: 16px;
  &::v-deep {
    .mct-card__title-info {
      color: rgba(0, 0, 0, 0.4);
    }

    .action-button {
      width: 140px;
    }
    .mct {
      background: none;
    }
    .justify-between {
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
    }
    .items-center {
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
    }
    .flex {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
    }
    .mct-card__desc {
      margin-bottom: 10px;
    }
  }
}

.active {
  display: block !important;
}

.pricing-mobile {
  display: none;
}

@media (max-width: 1280px) {
  .pricing-mobile.is-touch {
    display: block;
  }
  .pricing-desktop.is-desktop {
    display: none;
    &::v-deep {
      .mc__card-wrapper {
        display: block;
        flex-grow: initial;
        flex-basis: initial;
        position: initial;
        margin: 0;
        margin-bottom: 16px;
      }
      .mc__cards {
        display: block;
      }
    }
  }
}
.toggle__bar {
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 2px 3px;
  align-self: flex-start;
  order: 1;
  max-width: 420px;
  @apply rounded-3xl border border-solid w-full text-center mr-0 bg-base-0;
}

.toggle__marker {
  transition: -webkit-transform 0.3s ease;
  transition: transform 0.3s ease;
  transition: transform 0.3s ease, -webkit-transform 0.3s ease;
  will-change: transform;
  height: 34px;
  background-color: #2181c2;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.15);
  border-radius: 20px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

@media (max-width: 1280px) {
  .pricing-toggle {
    display: block;
  }
  .toggle__bar {
    margin: 0 auto 1.5rem;
  }
  .aha__save{
    flex-direction: column;
  }
}

.width-fixed{
  width: 59px;
}
.aha__save{
  flex-direction: column;
}
@media (max-width: 479px) {
  .toggle__title__subtitle-small {
    font-size: 14px;
  }
  .toggle__marker {
    width: 70px;
  }
  .toggle__marker.annual {
    -ms-transform: translateX(0);
    transform: translateX(0);
  }
  .toggle__marker.monthly {
    -ms-transform: translateX(67px);
    transform: translateX(67px);
  }
  .toggle__marker.one-time {
    -ms-transform: translateX(135px);
    transform: translateX(135px);
  }
  .toggle__marker.educational {
    -webkit-transform: translateX(203px);
    -ms-transform: translateX(203px);
    transform: translateX(203px);
  }
}

@media (min-width: 480px) {
  .toggle__marker {
    width: 104px;
  }
  .toggle__marker.annual {
    -webkit-transform: translateX(0);
    -ms-transform: translateX(0);
    transform: translateX(0);
  }
  .toggle__marker.monthly {
    -webkit-transform: translateX(101px);
    -ms-transform: translateX(101px);
    transform: translateX(101px);
  }
  .toggle__marker.one-time {
    -webkit-transform: translateX(204px);
    -ms-transform: translateX(204px);
    transform: translateX(204px);
  }
  .toggle__marker.educational {
    -webkit-transform: translateX(307px);
    -ms-transform: translateX(307px);
    transform: translateX(307px);
  }
}
.toggle__button {
  -webkit-transition: color 0.3s ease;
  -o-transition: color 0.3s ease;
  transition: color 0.3s ease;
  border-radius: 20px;
  color: rgba(0, 0, 0, 0.75);
  cursor: pointer;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 34px;
  line-height: 34px;
  position: relative;
  z-index: 2;
}

.toggle__button.active {
  background-color: $primary-color;
  color: #fff;
}

@media (min-width: 540px) {
  .toggle__button {
    font-size: 16px;
  }
}
#toggle-plan-one-time.active,
#toggle-plan-monthly.active,
#toggle-plan-annual.active,
#toggle-plan-educational.active {
  display: block !important;
}

#toggle--one-time.active,
#toggle--monthly.active,
#toggle--annual.active,
#toggle--educational.active {
  display: block !important;
}

#one-time-title.active,
#monthly-title.active,
#annual-title.active,
#educational-title.active {
  display: block !important;
}

.toggle__title__subtitle-small {
  color: rgba(0, 0, 0, 0.4);
}

//SVGs
.mc__card-image {
  position: absolute;
  top: 0;
  z-index: 1;
  width: 298px;
  opacity: 0.75;
}

.mc__card-image--yellow {
  top: 179px;
  left: 198px;
}

.mc__card-image--yellow .splash {
  fill: #ffae09;
}

.mc__card-image--yellow svg {
  -webkit-transform: rotate(-103deg);
  -ms-transform: rotate(-103deg);
  transform: rotate(-103deg);
}

.mc__card-image--green {
  top: -5px;
  right: 242px;
}

.mc__card-image--green .splash {
  fill: #28c270;
}

.mc__card-image--purple {
  top: 190px;
  right: -33px;
}

.e {
  fill: none;
  stroke: #d73b0a;
}

.mc__card-image--purple .splash {
  fill: #7669bf;
}

.mc__card-image--purple svg {
  -webkit-transform: rotate(-53deg);
  -ms-transform: rotate(-53deg);
  transform: rotate(-53deg);
}

.compare-button {
  background-color: #fff;
  color: rgba(0, 0, 0, 0.75);
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 20px;
  font-size: 16px;
  padding: 10px 0;
  -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  cursor: pointer;
}

//Mobile
button {
  cursor: pointer;
  width: 110px;
}

button:disabled {
  cursor: not-allowed !important;
  opacity: 0.6;
}

.title-open-edu{
  margin-top: 3rem;
  text-align: center;
  font-size: 1rem;
  span{
    b{
      font-size: 1.125rem;
    }
  }
  a{
    font-weight: 700;
    font-size: 16px;
  }
  svg{
    display: inline-block;
    vertical-align: baseline;
  }
}

.back-non-edu-plan{
  width: 100%;
  font-size: 1rem;
  text-align: right;
  font-weight: 700;
  align-items: center;
}
.pricing-container-mobile{
  padding-top: 0;
  .back-non-edu-plan_mobile {
    padding-left: 10px;
    padding-right: 10px;
    svg {
      display: inline-block;
      vertical-align: baseline;
    }

    a {
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 22px;
    }

    margin-bottom: 15px;
    display: block;
    text-align: left;
  }
}

@media (min-width: 1281px) {
  .pricing-container{
    .back-non-edu-plan_mobile{
      display: none;
    }
  }
}

@media (max-width: 1280px) {
  .back-non-edu-plan_desktop{
    display: none;
  }
}

@media (min-width: 480px) and (max-width: 1281px) {
  .pricing-container-mobile{
    .container-back-non-edu-plan{
      display: flex;
      justify-content: center;

      .back-non-edu-plan_mobile{
        text-align: center;
      }
    }
  }

  .pricing-toggle{
    &.show-edu-plan{
      justify-content: center;
    }
  }
}

</style>
